/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */

/**
 * Abacus state action status
 */
export type AbacusStateActionStatus =
  (typeof AbacusStateActionStatus)[keyof typeof AbacusStateActionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbacusStateActionStatus = {
  approved: "approved",
  complete: "complete",
  error: "error",
  init: "init",
  rejected: "rejected",
  running: "running",
} as const;
